export const SUPPORT_WORK_TYPE_COLORS = {
  EMAIL: "#8DBCF4",
  REQUEST: "#F2BD12",
};
